import { Popover, Transition } from '@headlessui/react'
import { PaperAirplaneIcon, XCircleIcon } from '@heroicons/react/solid'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import ClickAwayListener from 'react-click-away-listener'
import HomeApi from 'shared/api/home/Api'
import { UsersResponse } from 'shared/api/home/ApiGlobals'
import BaseCheckbox from 'shared/components/base/form/base-checkbox'
import MaskInput from 'shared/components/base/form/mask-input/MaskInput'
import { Whatsapp } from 'shared/components/icon-pack/icons'
import { useLoggedInUser } from 'shared/contexts/useLoggedInUser'

import { WhatsappOption, WhatsappTypeEnum } from './type'

type Props = {
  defaultPhonNumber?: string
}

const options: WhatsappOption[] = [
  { label: 'پیام معرفی من', value: WhatsappTypeEnum.INTRODUCE },
  { label: 'آدرس سایت آهن آنلاین', value: WhatsappTypeEnum.SITE },
  { label: 'اطلاعات سازمانی اکسین پولاد', value: WhatsappTypeEnum.OXIN_POLAD },
  { label: 'اطلاعات سازمانی نگین پولاد', value: WhatsappTypeEnum.NEGIN_POLAD },
]

const WhatsappTooltip = ({ defaultPhonNumber }: Props) => {
  const [whatsappData, setWhatsappData] = useState<{
    type: WhatsappTypeEnum
    number: string
  }>({ type: WhatsappTypeEnum.INTRODUCE, number: defaultPhonNumber || '' })

  const [userDetail, setUserDetail] = useState<UsersResponse>()

  const { loggedInUser } = useLoggedInUser()

  const handleCheckBox = (type: WhatsappTypeEnum) =>
    setWhatsappData({ ...whatsappData, type: type })

  const fetchUserDetail = () => {
    if (loggedInUser?.id)
      HomeApi.users.usersDetail(loggedInUser?.id).then((res) => {
        setUserDetail(res.data)
      })
  }

  const cancel = () => {
    setWhatsappData({
      type: WhatsappTypeEnum.INTRODUCE,
      number: defaultPhonNumber || '',
    })
  }

  const submit = async () => {
    if (userDetail?.id && String(whatsappData.number).split('').length === 11) {
      const requester: UsersResponse = {
        id: userDetail?.id,
        position: userDetail?.position,
        team: userDetail?.team,
        internalPhoneNumber: userDetail?.internalPhoneNumber,
        fullName: userDetail?.fullName,
        managerFullName: userDetail?.managerFullName,
        joiningDate: userDetail?.joiningDate,
        email: userDetail?.email,
        location: userDetail?.location,
        imageUrl: userDetail?.imageUrl,
        mobilePhoneNumber: userDetail?.mobilePhoneNumber,
      }

      const messages = {
        introduce: `سلام و عرض ادب%0a${loggedInUser?.fullname || ''} هستم، ${
          loggedInUser?.userPosition || ''
        } از شرکت آهن آنلاین.%0aپیرو تماس شما با مجموعه، پاسخگوی درخواست شما در زمینه خرید آهن آلات و محصولات فولادی هستم😊%0a
      %0a
      %0a☎️ شماره تماس : 02154712 داخلی ${
        loggedInUser?.userPhone || ''
      }%0aشماره موبایل: ${requester?.mobilePhoneNumber || ''}%0aایمیل: ${
          requester?.email || ''
        }`,

        site: `سلام و عرض ادب%0a${loggedInUser?.fullname || ''} هستم، ${
          loggedInUser?.userPosition || ''
        } از شرکت آهن آنلاین.%0aشما می توانید لیست قیمت آهن آلات و محصولات فولادی را از طریق لینک زیر در سایت آهن آنلاین مشاهده کنید😊%0a
      %0a%0ahttps://www.ahanonline.com`,

        oxin_polad: `سلام و عرض ادب%0a${loggedInUser?.fullname || ''} هستم، ${
          loggedInUser?.userPosition || ''
        } از شرکت آهن آنلاین.%0aاطلاعات سازمانی شرکت اکسین پولاد نقش جهان به شرح ذیل است:%0a%0aآدرس: استان تهران - تهران - خیابان شهید دکتر حبیب‌اله - پلاک 114 - ساختمان آهن آنلاین%0aکد پستی: 1455785783%0aکد اقتصادی: 411477776978%0aشناسه ملی: 14004674879%0aشماره فکس: 02154712 داخلی 6%0a`,

        negin_polad: `اطلاعات سازمانی نگین پولاد:%0a
      سلام و عرض ادب %0a
      %0a
      ${loggedInUser?.fullname || ''} هستم، ${
          loggedInUser?.userPosition || ''
        } از شرکت آهن آنلاین.%0a
      اطلاعات سازمانی شرکت اکسین پولاد نقش جهان به شرح ذیل است:%0a
      %0a
      آدرس: استان تهران - تهران - خیابان شهید دکتر حبیب‌اله - پلاک 114 - ساختمان آهن آنلاین%0a
      کد پستی: 1455785781%0a
      کد اقتصادی: 411569437969%0a
      شناسه ملی: 14006974689%0a
      شماره فکس: 02154712 داخلی6%0a`,
      }

      switch (whatsappData.type) {
        case WhatsappTypeEnum.INTRODUCE:
          window.open(
            `https://web.whatsapp.com/send?phone=98${whatsappData?.number?.slice(
              1
            )}&text=${messages?.introduce}`,
            '_blank'
          )
          break

        case WhatsappTypeEnum.SITE:
          window.open(
            `https://web.whatsapp.com/send?phone=98${whatsappData?.number?.slice(
              1
            )}&text=${messages?.site}`,
            '_blank'
          )
          break

        case WhatsappTypeEnum.OXIN_POLAD:
          window.open(
            `https://web.whatsapp.com/send?phone=98${whatsappData?.number?.slice(
              1
            )}&text=${messages?.oxin_polad}`,
            '_blank'
          )
          break

        case WhatsappTypeEnum.NEGIN_POLAD:
          window.open(
            `https://web.whatsapp.com/send?phone=98${whatsappData?.number?.slice(
              1
            )}&text=${messages?.negin_polad}`,
            '_blank'
          )
          break
      }
    }
  }

  useEffect(() => {
    fetchUserDetail()
  }, [])

  useEffect(() => {
    setWhatsappData({ ...whatsappData, number: defaultPhonNumber || '' })
  }, [defaultPhonNumber])

  return (
    <Popover className="relative">
      {({ close, open }) => {
        return (
          <>
            <Popover.Button>
              <Whatsapp
                className={`w-14 h-14 text-[#8B8F9A] hover:text-green-cta cursor-pointer ${
                  open ? '!text-green-cta' : ''
                }`}
              />
            </Popover.Button>
            <Transition
              enter="transition duration-100 ease-out"
              enterFrom="transform scale-95 opacity-0"
              enterTo="transform scale-100 opacity-100"
              leave="transition duration-100 ease-out"
              leaveFrom="transform scale-100 opacity-100"
              leaveTo="transform scale-95 opacity-0"
            >
              <ClickAwayListener onClickAway={cancel}>
                <Popover.Panel className="absolute z-10 bg-gunmetal-blue pt-[17px] pb-[19px] px-4 left-12 top-[-50px] rounded-lg ml-[14px]">
                  {/*----------- header---------------*/}
                  <div className={'flex justify-center text-[#7E92A2]'}>
                    <XCircleIcon
                      className={'w-5 absolute cursor-pointer right-4 top-3'}
                      onClick={() => {
                        cancel()
                        close()
                      }}
                    />
                    <span className={' font-normal text-[12px] leading-7'}>
                      ارتباط در واتساپ
                    </span>
                  </div>
                  {/*-----------end header---------------*/}

                  {/*-------------- input------------*/}
                  <MaskInput
                    value={whatsappData.number}
                    mask={'0000 000 0000'}
                    className={
                      '  w-[209px] h-[35px] rounded-lg !text-[#3639A6] bg-red-300 '
                    }
                    style={{ direction: 'ltr' }}
                    textClassName={
                      'text-text-purple  font-medium text-[13px] leading-[22px] pt-[2px]'
                    }
                    inputClassName={
                      'pl-[50px] box-content bg-white mt-2 !text-[#3639A6] '
                    }
                    onAccept={(value: string, maskRef: any) => {
                      setWhatsappData({
                        ...whatsappData,
                        number: maskRef?.unmaskedValue,
                      })
                    }}
                  />

                  {/*----- checkBoxes -----------*/}
                  <div className={'space-y-1 mt-[35px]'}>
                    {options?.map((node, index) => (
                      <BaseCheckbox
                        inputClassName={'!w-4 !h-4 leading-9'}
                        labelClassName={classNames(
                          'font-normal text-[12px] leading-9 text-white',
                          index != options.length - 1
                            ? 'border-b border-gray-600 '
                            : undefined
                        )}
                        onChange={() => handleCheckBox(node.value)}
                        key={index}
                        label={node.label}
                        value={node.value}
                        checked={node.value === whatsappData.type}
                      />
                    ))}
                  </div>

                  <div className={'w-full flex justify-end mt-[20px]'}>
                    <button
                      onClick={submit}
                      type="button"
                      className={
                        'bg-green-cta w-[40px] h-[40px] rounded-full p-3'
                      }
                    >
                      <PaperAirplaneIcon
                        className={'text-white rotate-[-90deg]'}
                      />
                    </button>
                  </div>
                </Popover.Panel>
              </ClickAwayListener>
            </Transition>
          </>
        )
      }}
    </Popover>
  )
}
export default WhatsappTooltip
